<template>
	<div class=" paddingv20">
		<div  v-show = "showFresh && freshData.length" class="paddingb20">
			<div class="fs-14 text-dark flex-container"><div class="flex1 text-black">最近搜索</div><i class="icon-delete" @click="hideFresh"
					data-scp="hideFresh.0"></i></div>
			<div class="clearfix" style="max-height:84px;overflow: hidden">
				<div class="btn-search" v-for="item in freshData" v-text="item" data-scp="freshData.{{$index}}" :data-bk="`type-${bkByType[type]}`" @click.stop="goFreshPage(item,$index)"></div>
			</div>
		</div>
		<div class="margin-bottom:40px;" v-show = "showHot">
			<p class="paddingt40 paddingh20">热门搜索</p>
			<!-- <div class="container">
				<p class="span6 fs-13 margint30" data-scp="hotData.{{$index}}" v-for="item in hotData" :data-bk="`type-${bkByType[type]}`"
				   :data-trace-id="item.traceId" v-text="item.title"  :class="item.hot === 0?'text-red':'text-dark' " @click.stop="goHotPage(item,$index,item.traceId)"></p>
			</div> -->
			<div v-text="str11"></div>
			<cmui-list :col="2" :space="20" class="marginh20 margint30">
				<cmui-list-item v-for="item in hotData">
					<a :href="item.clickUrl"
					:data-bk="`type-${type}`"
					:data-scp="`hotData.${$index}`"
					:data-trace-id="item.traceId"
					class="flex-container left searchHot br8 padding10">
						<div class="img-container" style="width:50px;height:50px">
							<img :src="item.imageUrl" style="border-radius:4px;" alt="">
						</div>
						<div class="marginl10">
							<div class="text-limit1 fs-14" :class="item.hot === 0?'text-red':'text-black'" v-text="item.title"></div>
							<div class="text-limit1 fs-10" style="color:#848484;" v-text="item.subTitle"></div>
						</div>
					</a>
				</cmui-list-item>
			</cmui-list>

		</div>
	</div>
</template>
<style lang="scss">
    .btn-search{
	    color: #666;
	    background: #f5f5f5;
	    font-size: 13px;
	    overflow: hidden;
	    float: left;
	    max-width: 100%;
	    border-radius: 500px;
	    min-width: 20px;
	    line-height: 1;
	    vertical-align: middle;
	    white-space: nowrap;
	    text-overflow: ellipsis;
	    text-align: center;
	    color: white;
	    position: relative;
	    color:#666;
	    background:#f5f5f5;
	    padding:7px 17px;
	    margin: 10px 10px 0 0;
		border: 1px solid transparent;
	}
	.btn-search.current{
		border: 1px solid #ff4c48;
		background-color: white;
		color:#ff4c48;
	}
	.tg-tabbar.theme_5 {
	    margin-bottom: 0px;
	    padding-bottom: 0px;
	}
	.tg-tabbar.theme_5 .tg-tabbar-item {
	    padding: 10px;
	}
	.classify{
		height:calc(100% - 86px);
	}
	.bg-gray{
		background:#f5f5f5;
	}
	.padding5 {
	    padding: .0666666667rem;
	}
	[v-show] {
		display: none;
	}
	.mask{
		position: fixed;
	    z-index: 1001!important;
	    top: 0;
	    left: 0;
	    bottom: 0;
	    right: 0;
	    background-color: rgba(0,0,0,0.75);
	}
	.searchHot{
		background:#F3F4F5;

	}
	.br8{
		border-radius:8px;
	}
</style>
<script>
import app from "app";
import tgs from '../../analyse';

export default{
    props:{
    	hotData: Array,
        freshData:Array,
        showFresh:{
        	type: Boolean,
        	default: true
        },
        type:{
        	type:String,
        	default: ''
        }
    },
    watch: {

    },
    computed: {
    	showHot:function(){
    		return this.hotData.length?true:false;
    	},
        bkByType(){
    	    return {
                overseas:2,
                counterSale:3,
				timeLimit:'index'
            }
		}
    },
    methods:{
        hideFresh:function() {
        	let that = this;
        	// 弹窗询问是否清除cookie中的搜索历史
        	maple.confirm({
        		content: '<div class="text-center">确定清空最近搜索吗？</div>',
        		okStyle: 'color: #ff4c48',
        		okFn: function(fresh) {
        			that.showFresh = false;
        			maple.pageIns.setCookie('freshSearchKeys','',365);
        		}
        	})
        },
        goFreshPage:function(item,index) {
        	/**
        	 * TODO
        	 * 最近搜索记录的这条记录在原本的位置删掉，移动到首位,设置cookie
        	 * 跳转到搜索结果页
        	 */
        	tgs.trackSCP('07.searchword.freshData.'+index, 'type-'+this.bkByType[this.type]);
        	let searchResultUrl = '/search/searchResult.html'
        		,scp = maple.pageIns.page + '.freshData.'+index
        		,searchList = this.freshData;

        	searchList.splice(index,1);
        	searchList.unshift(item);
        	maple.pageIns.setCookie('freshSearchKeys',searchList.slice(0,10).join(','),365)
        	this.$dispatch('freshSearch',item,this.type);

        },
        goHotPage:function(item,index,traceId) {
        	/**
        	 * TODO
        	 * 热门搜索点击热搜词，跳转到设置好的clickUrl
        	 */
        	// this.$dispatch('goHotPage',item,index);
            tgs.trackSCP('07.searchword.hotData.'+index, 'type-'+this.bkByType[this.type], traceId);
        	let scp = maple.pageIns.page + '.hotData.'+index
        	maple.pageIns.changePage(item.clickUrl,{scp:scp})
        }
    }
}
</script>
